// registerCanvasPanzoom / unregisterCanvasPanzoom — the ONE documented way for a pan/zoom canvas, a shell page or
// an installed workspace MODULE's canvas page (manifest `canvasRoutes`), to drive the shell Zoombar.
//
// The root-mounted Zoombar (shared/components/Zoombar.js → ZoomInNavbar.js) reads the live canvas every frame from
// window.__canvasGlobalScope = { panzoomInstance, positions, scale }. The shell boards wrote that global
// themselves (tickets/pages/board.js onTransform …). A module never touches `window` (module publish audit, frank
// serialization), so it registers the instance it got from initPanzoomBoard instead:
//
//   const pz = el.call('initPanzoomBoard', { getScene, getDots, … })
//   el.call('registerCanvasPanzoom', pz, { fit: () => el.call('myFit') })   // −, %, +, presets and Fit drive pz
//   …
//   el.call('unregisterCanvasPanzoom', pz)                                    // in onBeforeRemove
//
// `fit` (optional) is what the Zoombar's Fit preset runs. It rides on the INSTANCE (`pz.__fit`, next to the v2
// project canvas's `pz.__v2` marker), never on the global scope: a board that writes __canvasGlobalScope itself
// (tickets, studios) replaces the instance and with it the fit, so the Zoombar can never offer a stale Fit that
// belongs to a canvas no longer on screen (ZoomInNavbar: a registered `__fit` wins over fitToSelection). Registering
// mirrors pz's transform into `positions` / `scale` — the % label and the presets read them — and returns the
// unregister function. Unregistering clears the scope only while `pz` is still the registered instance, so a canvas
// mounted after this one keeps its registration.
//
// Self-contained exports (FA204 / frank trap): no module-scope consts, no sibling calls.
export function registerCanvasPanzoom(pz, opts = {}) {
  if (typeof window === 'undefined' || !pz || typeof pz.getTransform !== 'function') return () => {}
  const gs = (window.__canvasGlobalScope = window.__canvasGlobalScope || {})
  const sync = () => {
    const t = pz.getTransform()
    if (!gs.positions) gs.positions = { x: 0, y: 0 }
    gs.positions.x = t.x
    gs.positions.y = t.y
    gs.scale = t.scale
  }
  if (gs.panzoomInstance && gs.panzoomInstance !== pz) {
    const prev = gs.panzoomInstance
    if (prev.__zoombarSync && typeof prev.off === 'function')
      prev.off('transform', prev.__zoombarSync)
    prev.__zoombarSync = null
  }
  gs.panzoomInstance = pz
  pz.__fit = opts && typeof opts.fit === 'function' ? opts.fit : null
  pz.__zoombarSync = sync
  sync()
  if (typeof pz.on === 'function') pz.on('transform', sync)
  return () => {
    const live = window.__canvasGlobalScope
    if (!live || live.panzoomInstance !== pz) return
    if (typeof pz.off === 'function') pz.off('transform', sync)
    pz.__zoombarSync = null
    pz.__fit = null
    live.panzoomInstance = null
  }
}

export function unregisterCanvasPanzoom(pz) {
  if (typeof window === 'undefined' || !pz) return
  const live = window.__canvasGlobalScope
  if (!live || live.panzoomInstance !== pz) return
  if (pz.__zoombarSync && typeof pz.off === 'function') pz.off('transform', pz.__zoombarSync)
  pz.__zoombarSync = null
  pz.__fit = null
  live.panzoomInstance = null
}
